import { useSelector } from 'react-redux';

import { RootState } from '../../Store';
import { FilterState } from '../../Store/Filter/state';
import { compareFilterValuesWithInitial } from '../../Helpers/Filter';

const useFilterIsInitial = (): boolean => {
    const { filterValues } = useSelector<RootState, FilterState>(state => state.filter);

    return compareFilterValuesWithInitial(filterValues);
};

export default useFilterIsInitial;
